import './DataTableEmptyState.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var emptyState = _7a468({defaultClassName:'_lvf8p50-3-5-0',variantClassNames:{minWidth:{true:'_lvf8p51-3-5-0'}},defaultVariants:{},compoundVariants:[]});